import React, { Fragment, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  Button,
  Label,
  ButtonDropdown,
  Form,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardTitle,
  CardText,
  Popover,
  PopoverBody,
} from "reactstrap";
import CommonDataTable from "../../../../share-components/table/commonDataTable";

// const sampleData = [
//   {
//     id: 1,
//     action_taken_on: "2025-04-15 12:45:22",
//     action_taken_by: "Ajay",
//     action: "Approved",
//     partner_name: "ASOS",
//     reason: "Reason 01",
//     order: {
//       id: 5454,
//       mp_order_id: "#641645",
//       order_date: "2025-04-25 20:12:56",
//       dispatch_date: "2025-04-25 65:12:32",
//       items: [
//         {
//           item_id: 8823441,
//           sku: "ZARA-SKU-451",
//           excel_sku: "ZARA-SKU-451",
//           price: 120.0,
//           excel_price: 115.5,
//           qty: 3,
//           excel_qty: 3,
//           is_sku_mismatch: false,
//           is_price_mismatch: true,
//           is_quantity_mismatch: false,
//           refund_status: "Not Refunded",
//           excel_refund_status: "Refunded",
//           statuses: ["Refund Status Mismatch"],
//         },
//         {
//           item_id: 8823442,
//           sku: "ZARA-SKU-452",
//           excel_sku: "ZARA-SKU-452",
//           price: 85.0,
//           excel_price: 70.0,
//           is_sku_mismatch: false,
//           is_price_mismatch: true,
//           is_quantity_mismatch: false,
//           qty: 1,
//           excel_qty: 2,
//           refund_status: "",
//           excel_refund_status: "",
//           statuses: ["Price Mismatch", "Quantity Mismatch"],
//         },
//       ],
//     },
//   },
// ];

const sampleData = [
  {
    id: 1,
    action_taken_on: "2025-04-15 12:45:22",
    action_taken_by: "Ajay",
    action: "Approved",
    partner_name: "ASOS",
    reason: "Reason 01",
    order: {
      id: 5454,
      mp_order_id: "#641645",
      order_date: "2025-04-25 20:12:56",
      dispatch_date: "2025-04-25 16:12:32",
      items: [
        {
          item_id: 8823441,
          sku: "ZARA-SKU-451",
          excel_sku: "ZARA-SKU-451",
          price: 120.0,
          excel_price: 115.5,
          qty: 3,
          excel_qty: 3,
          is_sku_mismatch: false,
          is_price_mismatch: true,
          is_quantity_mismatch: false,
          refund_status: "Not Refunded",
          excel_refund_status: "Refunded",
          statuses: ["Refund Status Mismatch"],
        },
        {
          item_id: 8823442,
          sku: "ZARA-SKU-452",
          excel_sku: "ZARA-SKU-452",
          price: 85.0,
          excel_price: 70.0,
          qty: 1,
          excel_qty: 2,
          is_sku_mismatch: false,
          is_price_mismatch: true,
          is_quantity_mismatch: true,
          refund_status: "",
          excel_refund_status: "",
          statuses: ["Price Mismatch", "Quantity Mismatch"],
        },
      ],
    },
  },

  // Record 2
  {
    id: 2,
    action_taken_on: "2025-05-02 09:22:11",
    action_taken_by: "Nimal",
    action: "Rejected",
    partner_name: "ZARA",
    reason: "Incorrect Details",
    order: {
      id: 5521,
      mp_order_id: "#784512",
      order_date: "2025-05-01 13:45:00",
      dispatch_date: "2025-05-01 18:10:22",
      items: [
        {
          item_id: 9823412,
          sku: "ZARA-SKU-888",
          excel_sku: "ZARA-SKU-889",
          price: 150.0,
          excel_price: 150.0,
          qty: 2,
          excel_qty: 2,
          is_sku_mismatch: true,
          is_price_mismatch: false,
          is_quantity_mismatch: false,
          refund_status: "Refunded",
          excel_refund_status: "Refunded",
          statuses: ["SKU Mismatch"],
        },
      ],
    },
  },

  // Record 3
  {
    id: 3,
    action_taken_on: "2025-06-10 14:33:48",
    action_taken_by: "Sara",
    action: "Pending",
    partner_name: "Amazon",
    reason: "Waiting for confirmation",
    order: {
      id: 6322,
      mp_order_id: "#998721",
      order_date: "2025-06-09 11:22:10",
      dispatch_date: "2025-06-09 19:00:12",
      items: [
        {
          item_id: 7723112,
          sku: "AMZ-5512",
          excel_sku: "AMZ-5512",
          price: 49.99,
          excel_price: 49.99,
          qty: 1,
          excel_qty: 3,
          is_sku_mismatch: false,
          is_price_mismatch: false,
          is_quantity_mismatch: true,
          refund_status: "Not Refunded",
          excel_refund_status: "Not Refunded",
          statuses: ["Quantity Mismatch"],
        },
        {
          item_id: 7723113,
          sku: "AMZ-5513",
          excel_sku: "AMZ-5514",
          price: 89.99,
          excel_price: 79.99,
          qty: 2,
          excel_qty: 2,
          is_sku_mismatch: true,
          is_price_mismatch: true,
          is_quantity_mismatch: false,
          refund_status: "",
          excel_refund_status: "",
          statuses: ["SKU Mismatch", "Price Mismatch"],
        },
      ],
    },
  },

  // Record 4
  {
    id: 4,
    action_taken_on: "2025-07-18 17:12:09",
    action_taken_by: "Kasun",
    action: "Approved",
    partner_name: "H&M",
    reason: "Verified",
    order: {
      id: 7201,
      mp_order_id: "#555741",
      order_date: "2025-07-17 10:15:55",
      dispatch_date: "2025-07-17 15:45:32",
      items: [
        {
          item_id: 6612344,
          sku: "HM-SKU-223",
          excel_sku: "HM-SKU-223",
          price: 65.5,
          excel_price: 65.5,
          qty: 4,
          excel_qty: 4,
          is_sku_mismatch: false,
          is_price_mismatch: false,
          is_quantity_mismatch: false,
          refund_status: "Refunded",
          excel_refund_status: "Refunded",
          statuses: [],
        },
      ],
    },
  },

  // Record 5
  {
    id: 5,
    action_taken_on: "2025-08-01 08:55:40",
    action_taken_by: "Ruwan",
    action: "Rejected",
    partner_name: "Nike",
    reason: "Mismatch found",
    order: {
      id: 8122,
      mp_order_id: "#741259",
      order_date: "2025-07-31 09:42:16",
      dispatch_date: "2025-07-31 20:32:22",
      items: [
        {
          item_id: 5599121,
          sku: "NKE-1001",
          excel_sku: "NKE-1001",
          price: 120.0,
          excel_price: 135.0,
          qty: 1,
          excel_qty: 1,
          is_sku_mismatch: false,
          is_price_mismatch: true,
          is_quantity_mismatch: false,
          refund_status: "Not Refunded",
          excel_refund_status: "Not Refunded",
          statuses: ["Price Mismatch"],
        },
        {
          item_id: 5599122,
          sku: "NKE-1002",
          excel_sku: "NKE-9999",
          price: 200.0,
          excel_price: 200.0,
          qty: 2,
          excel_qty: 2,
          is_sku_mismatch: true,
          is_price_mismatch: false,
          is_quantity_mismatch: false,
          refund_status: "",
          excel_refund_status: "",
          statuses: ["SKU Mismatch"],
        },
      ],
    },
  },
];

const sampleEmailData = [
  {
    id: 12,
    partner_id: 11,
    partner_name: "ASOS",
    sent_to: "Ajay",
    CC: "Clare, Kugans",
    bcc: "Balu",
    sent_on: "2025-12-07 02:35:54",
    is_success: 1,
    message: "Successfully Sent",
    email_response: null,
  },
  {
    id: 13,
    partner_id: 5,
    partner_name: "Debenams",
    sent_to: "Yathu",
    CC: "Subangan",
    bcc: "Methan",
    sent_on: "2025-12-07 02:35:54",
    is_success: 0,
    message: "Invalid Email Address",
    email_response: {
      "error message": "Invalid Email Address",
      message: "Your Email is Invalid, Please check and try again",
      email: "partner@gmail.com",
    },
  },
];

const ChildMimatchStatus = ({ partnerName, partnerVal, isPrice = false }) => {
  return (
    <div>
      <p className="mb-0">
        Goddiva : <span>{partnerVal}</span>
      </p>
      <p style={{ fontWeight: 600, marginTop: 0 }}>
        {partnerName} : <span>{isPrice ? `£ ${Number(partnerVal).toFixed(2)}` : `${partnerVal}`}</span>
      </p>
    </div>
  );
};

const PopoverBasicItem = (props) => {
  const { id, data } = props;
  const isSuccess = data.is_success ?? false;
  const message = data.message ?? "";
  const [popover, setPopover] = useState(false);
  const Toggle = () => setPopover(!popover);
  return (
    <>
      {isSuccess ? (
        <p className="text-success" id={"Popover-" + id}>
          {message}
        </p>
      ) : (
        <p className="text-danger" id={"Popover-" + id}>
          {message}{" "}
          <span id={"Popover-" + id} style={{ cursor: "pointer", marginLeft: "6px" }}>
            <i class="fa fa-info-circle" aria-hidden="true"></i>
          </span>
        </p>
      )}

      {!isSuccess && (
        <Popover placement="bottom" isOpen={popover} target={"Popover-" + id} toggle={Toggle} trigger="hover">
          <PopoverBody>
            {data.email_response && (
              <pre className="mb-0">
                {Object.entries(data.email_response)
                  .map(([key, value]) => `${key}: ${value}`)
                  .join("\n")}
              </pre>
            )}
          </PopoverBody>
        </Popover>
      )}
    </>
  );
};

function ReportContent({ orderState }) {
  const tableColumns = [
    {
      name: "Action Taken on",
      selector: (row) => row.action_taken_on,
      sortable: true,
      center: false,
    },
    {
      name: "Action Taken By",
      selector: (row) => row.action_taken_by,
      sortable: true,
      center: false,
    },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
      center: false,
    },
    {
      name: "Reason",
      selector: (row) => row.reason,
      sortable: true,
      center: false,
    },
  ];

  const emailHistorytableColumns = [
    {
      name: "Email Sent to",
      selector: (row) => row.sent_to,
      sortable: true,
      center: false,
    },
    {
      name: "CC",
      selector: (row) => row.CC,
      sortable: true,
      center: false,
    },
    {
      name: "BCC",
      selector: (row) => row.bcc,
      sortable: true,
      center: false,
    },
    {
      name: "Sent on",
      selector: (row) => row.sent_on,
      sortable: true,
      center: false,
    },
    {
      name: "Status",
      selector: (row) => <PopoverBasicItem id={row.id} data={row} />,
      sortable: true,
      center: false,
    },
  ];

  const SalesExpandedComponent = ({ data }) => {
    console.log("DATAAAA", data);
    const order = data.order;
    const items = data.order.items;

    console.log("childData", order);
    console.log("items", items);

    const childTableColumns = [
      {
        name: "MP Order ID",
        selector: (row) => row.mp_order_id,
        sortable: false,
        center: false,
      },
      {
        name: "Order Date",
        selector: (row) => row.order_date,
        sortable: false,
        center: false,
      },
      {
        name: "Dispatch Date",
        selector: (row) => row.dispatch_date,
        sortable: false,
        center: false,
      },
      {
        name: "SKU",
        selector: (row) => {
          return (
            items &&
            items.length > 0 &&
            items.map((item) => {
              const mpSku = item.sku;
              const excelSku = item.excel_sku;
              const isPrice = false;

              return (
                <div>
                  <p className="mb-0">
                    Goddiva : <span>{mpSku}</span>
                  </p>
                  <p style={{ fontWeight: 600, marginTop: 0 }}>
                    {data.partner_name} : <span>{isPrice ? `£ ${Number(excelSku).toFixed(2)}` : `${excelSku}`}</span>
                  </p>
                </div>
              );
            })
          );
        },
        sortable: false,
        left: true,
        width: "200px",
      },
      {
        name: "Price",
        selector: (row) => {
          return (
            items &&
            items.length > 0 &&
            items.map((item) => {
              const mpPrice = item.price;
              const excelPrice = item.excel_price;
              const isPrice = true;

              return (
                <div>
                  <p className="mb-0">
                    Goddiva : <span>{mpPrice}</span>
                  </p>
                  <p style={{ fontWeight: 600, marginTop: 0 }}>
                    {data.partner_name} : <span>{isPrice ? `£ ${Number(excelPrice).toFixed(2)}` : `${excelPrice}`}</span>
                  </p>
                </div>
              );
            })
          );
        },
        sortable: false,
        left: true,
        width: "200px",
      },
      {
        name: "QTY",
        selector: (row) => {
          return (
            items &&
            items.length > 0 &&
            items.map((item) => {
              const mpQty = item.qty;
              const excelQty = item.excel_qty;
              const isPrice = false;

              return (
                <div>
                  <p className="mb-0">
                    Goddiva : <span>{mpQty}</span>
                  </p>
                  <p style={{ fontWeight: 600, marginTop: 0 }}>
                    {data.partner_name} : <span>{isPrice ? `£ ${Number(excelQty).toFixed(2)}` : `${excelQty}`}</span>
                  </p>
                </div>
              );
            })
          );
        },
        sortable: false,
        left: true,
        width: "200px",
      },
      {
        name: "Status",
        selector: () =>
          items.map((item) => (
            <div key={item.item_id}>
              {item.statuses && item.statuses.length > 0 ? (
                item.statuses.map((s, i) => (
                  <p key={i} style={{ color: "#dc0000", margin: 0 }}>
                    {s}
                  </p>
                ))
              ) : (
                <p style={{ color: "#139a35", margin: 0 }}>No Mismatch</p>
              )}
            </div>
          )),
        width: "200px",
        sortable: false,
      },
    ];

    return (
      <div className="px-5 pt-3 pb-5 border-bottom">
        <CommonDataTable headerColumns={childTableColumns} gridData={[order]} noAction pagination={false} />
      </div>
    );
  };
  const ReturnExpandedComponent = ({ data }) => {
    const order = data.order;
    const items = data.order.items;
    
    const childTableColumns = [
      {
        name: "MP Order ID",
        selector: (row) => row.mp_order_id,
        sortable: false,
        center: false,
      },
      {
        name: "Order Date",
        selector: (row) => row.order_date,
        sortable: false,
        center: false,
      },
      {
        name: "Dispatch Date",
        selector: (row) => row.dispatch_date,
        sortable: false,
        center: false,
      },
      {
        name: "Return Date",
        selector: (row) => row.return_date,
        sortable: false,
        center: false,
      },
      {
        name: "SKU",
        selector: (row) => {
          return (
            items &&
            items.length > 0 &&
            items.map((item) => {
              const mpSku = item.sku;
              const excelSku = item.excel_sku;
              const isPrice = false;

              return (
                <div>
                  <p className="mb-0">
                    Goddiva : <span>{mpSku}</span>
                  </p>
                  <p style={{ fontWeight: 600, marginTop: 0 }}>
                    {data.partner_name} : <span>{isPrice ? `£ ${Number(excelSku).toFixed(2)}` : `${excelSku}`}</span>
                  </p>
                </div>
              );
            })
          );
        },
        sortable: false,
        left: true,
        width: "200px",
      },
      {
        name: "Price",
        selector: (row) => {
          return (
            items &&
            items.length > 0 &&
            items.map((item) => {
              const mpPrice = item.price;
              const excelPrice = item.excel_price;
              const isPrice = true;

              return (
                <div>
                  <p className="mb-0">
                    Goddiva : <span>{mpPrice}</span>
                  </p>
                  <p style={{ fontWeight: 600, marginTop: 0 }}>
                    {data.partner_name} : <span>{isPrice ? `£ ${Number(excelPrice).toFixed(2)}` : `${excelPrice}`}</span>
                  </p>
                </div>
              );
            })
          );
        },
        sortable: false,
        left: true,
        width: "200px",
      },
      {
        name: "QTY",
        selector: (row) => {
          return (
            items &&
            items.length > 0 &&
            items.map((item) => {
              const mpQty = item.qty;
              const excelQty = item.excel_qty;
              const isPrice = false;

              return (
                <div>
                  <p className="mb-0">
                    Goddiva : <span>{mpQty}</span>
                  </p>
                  <p style={{ fontWeight: 600, marginTop: 0 }}>
                    {data.partner_name} : <span>{isPrice ? `£ ${Number(excelQty).toFixed(2)}` : `${excelQty}`}</span>
                  </p>
                </div>
              );
            })
          );
        },
        sortable: false,
        left: true,
        width: "200px",
      },
      {
        name: "Refund Status",
        selector: (row) => {
          return (
            items &&
            items.length > 0 &&
            items.map((item) => {
              const mpRefundStatus = item.refund_status;
              const excelRefundStatus = item.excel_refund_status;
              const isPrice = false;

              return (
                <div>
                  <p className="mb-0">
                    Goddiva : <span>{mpRefundStatus}</span>
                  </p>
                  <p style={{ fontWeight: 600, marginTop: 0 }}>
                    {data.partner_name} : <span>{isPrice ? `£ ${Number(excelRefundStatus).toFixed(2)}` : `${excelRefundStatus}`}</span>
                  </p>
                </div>
              );
            })
          );
        },
        sortable: false,
        left: true,
        width: "200px",
      },
      {
        name: "Status",
        selector: () =>
          items.map((item) => (
            <div key={item.item_id}>
              {item.statuses && item.statuses.length > 0 ? (
                item.statuses.map((s, i) => (
                  <p key={i} style={{ color: "#dc0000", margin: 0 }}>
                    {s}
                  </p>
                ))
              ) : (
                <p style={{ color: "#139a35", margin: 0 }}>No Mismatch</p>
              )}
            </div>
          )),
        width: "200px",
        sortable: false,
      },
    ];

    return (
      <div className="px-5 pt-3 pb-5 border-bottom">
        <CommonDataTable headerColumns={childTableColumns} gridData={[order]} noAction pagination={false} />
      </div>
    );
  };

  return (
    <Fragment>
      {orderState.invoiceSales.length > 0 && (
        <Card className="mt-4 ribbon-wrapper">
          <CardBody>
            <div className="ribbon ribbon-clip ribbon-dark h6">Order Descrepancies</div>
            <div className="table-responsive product-table">
              <CommonDataTable
                headerColumns={tableColumns}
                gridData={orderState.invoiceSales || []}
                noAction
                expandableRows
                expandableRowsComponent={SalesExpandedComponent}
                pagination={false}
              />
            </div>
          </CardBody>
        </Card>
      )}
      {orderState.invoiceReturns.length > 0 && (
        <Card className="mt-4 ribbon-wrapper">
          <CardBody>
            <div className="ribbon ribbon-clip ribbon-dark h6">Return Descrepancies</div>
            <div className="table-responsive product-table">
              <CommonDataTable
                headerColumns={tableColumns}
                gridData={orderState.invoiceReturns || []}
                noAction
                expandableRows
                expandableRowsComponent={ReturnExpandedComponent}
                pagination={false}
              />
            </div>
          </CardBody>
        </Card>
      )}

      <Card>
        <CardBody>
          <div className="ribbon ribbon-clip ribbon-dark h6">Email History</div>
          <div className="table-responsive product-table">
            <CommonDataTable headerColumns={emailHistorytableColumns} gridData={sampleEmailData} noAction />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
}

export default ReportContent;
